/**
 * Page Transitions
 * Smooth page transitions without libraries
 * Optimized for WordPress compatibility
 */

export function initPageTransitions() {
  "use strict";

  const mainElement = document.querySelector("main");
  if (!mainElement) return; // Exit if no main element found

  // Must exceed _transition.scss main opacity duration so fade-out can finish before fallback navigation.
  const TRANSITION_FALLBACK_MS = 900;

  // Remove no-js class if present
  document.documentElement.classList.remove("no-js");

  // Function to show page
  function showPage() {
    mainElement.classList.add("page-loaded");
    mainElement.classList.remove("page-transitioning");
  }

  // Show the page immediately when script runs
  showPage();

  const navigateAfterFadeOut = (href) => {
    let completed = false;
    let fallbackId;

    const done = () => {
      if (completed) {
        return;
      }
      completed = true;
      mainElement.removeEventListener("transitionend", onTransitionEnd);
      window.clearTimeout(fallbackId);
      window.location.href = href;
    };

    const onTransitionEnd = (event) => {
      if (event.target !== mainElement || event.propertyName !== "opacity") {
        return;
      }
      done();
    };

    mainElement.addEventListener("transitionend", onTransitionEnd);
    fallbackId = window.setTimeout(done, TRANSITION_FALLBACK_MS);
  };

  // Handle link clicks for smooth transitions
  document.addEventListener("click", function (event) {
    const link = event.target.closest("a");
    const hrefAttr = link?.getAttribute("href") ?? "";

    // Check if it's a valid internal link
    if (
      !link ||
      hrefAttr.includes("#") || // Skip anchor links (same-page and cross-page, e.g. /page#section)
      hrefAttr.indexOf("mailto:") === 0 || // Skip mailto links
      hrefAttr.indexOf("tel:") === 0 || // Skip tel links
      hrefAttr.indexOf("javascript:") === 0 || // Skip javascript links
      link.target === "_blank" || // Skip external links
      link.download || // Skip download links
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey || // Skip modified clicks
      link.hostname !== window.location.hostname
    ) {
      // Skip external domains
      return;
    }

    // NEW APPROACH: Skip transition completely for header links
    if (link.closest("header")) {
      return; // Let header links navigate normally without transition
    }

    event.preventDefault();

    mainElement.classList.remove("page-loaded");
    mainElement.classList.add("page-transitioning");

    navigateAfterFadeOut(link.href);
  });

  // Handle browser back/forward buttons
  window.addEventListener("pageshow", function (event) {
    showPage();
  });

  // Handle page hide for transitions
  window.addEventListener("pagehide", function (event) {
    mainElement.classList.remove("page-loaded");
    mainElement.classList.add("page-transitioning");
  });
}
